import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledDesktopContentComponent = styled.div`
  height: 100%;

  .asset-part-wrapper {
    width: 100%;
    height: 100%;
  }

  .text-part-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;

    width: 56vw;

    display: flex;
    align-items: center;

    padding: 16px 0 16px 80px;
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .text-part-wrapper {
      padding: 16px 0 16px 54px;
    }
  }
`;
